import { useEffect, useState } from "react";
import { toast } from "sonner";
import { History } from "lucide-react";
import { api } from "@/lib/api";
import { estadoLabel } from "@/lib/format";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const MontoOperacion = ({ op, onSaved }) => {
  const [monto, setMonto] = useState(op.monto ?? "");
  const [moneda, setMoneda] = useState(op.moneda || "MXN");
  useEffect(() => { setMonto(op.monto ?? ""); setMoneda(op.moneda || "MXN"); }, [op.monto, op.moneda]);
  const save = async (m, mon) => {
    try {
      await api.put(`/operaciones/${op.id}`, { monto: m === "" ? null : Number(m), moneda: mon });
      toast.success("Monto guardado");
      onSaved();
    } catch { toast.error("No se pudo guardar el monto"); }
  };
  return (
    <div className="p-3 rounded-xl bg-[#F3EFE6]/50" data-testid="op-monto">
      <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Precio o renta</div>
      <div className="mt-1 flex flex-col gap-2">
        <input type="number" value={monto} onChange={(e) => setMonto(e.target.value)} onBlur={() => save(monto, moneda)}
          placeholder="0.00" data-testid="op-monto-input"
          className="w-full h-10 px-3 rounded-lg border border-[#CBD5E1] bg-white text-sm" />
        <Select value={moneda} onValueChange={(v) => { setMoneda(v); save(monto, v); }}>
          <SelectTrigger className="w-full h-10" data-testid="op-moneda-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="MXN">MXN</SelectItem><SelectItem value="USD">USD</SelectItem></SelectContent>
        </Select>
      </div>
      <p className="text-[11px] text-slate-500 mt-1">Se prellena en cada documento nuevo; ahí lo puedes cambiar.</p>
    </div>
  );
};

export const HistorialEstados = ({ items }) => {
  if (!items?.length) return null;
  return (
    <section className="bm-card p-5 mb-6" data-testid="op-historial">
      <h2 className="font-heading font-bold text-slate-900 flex items-center gap-2 mb-3"><History className="w-4 h-4" /> Historial de estados</h2>
      <ol className="space-y-2">
        {[...items].reverse().map((h, i) => (
          <li key={i} className="text-sm text-slate-700 flex flex-wrap gap-x-2" data-testid={`op-historial-${i}`}>
            <span className="text-slate-500">{new Date(h.fecha).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" })}</span>
            <span>{h.anterior ? <>{estadoLabel[h.anterior] || h.anterior} → <b>{estadoLabel[h.nuevo] || h.nuevo}</b></> : <>Creada como <b>{estadoLabel[h.nuevo] || h.nuevo}</b></>}</span>
            <span className="text-slate-500">· {h.usuario}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};
